import Api from "@src/api";
export const usefulLifeApi= {
 
  getUsefulLifeByCategory(params) {
    return Api().get("UsefulLifeMaster",{params});
  },
  
};
